import styled from '@emotion/styled';

export const ReplyContainer = styled.div`
  margin-bottom: 16px;
`;
export const ReplyText = styled.p`
  margin-bottom: 6px;
  font-weight: bold;
`;
export const ReplyName = styled.p`
  margin-bottom: 3px;
  font-weight: bold;
  color: #7f8287;
`;
export const ReplyTime = styled.p`
  font-weight: bold;
  color: #7f8287;
`;
